import "./SubInfoItem.scss";

export interface SubInfoItemProps {
  title: string;
  content: string | React.ReactNode;
  className?: string;
}

export const SubInfoItem = ({
  title,
  content,
  children,
}: React.PropsWithChildren<SubInfoItemProps>) => {
  return (
    <div className="subinfo">
      {children}
      <div className="subinfo__content">
        <div className="subinfo__title">{title}</div>
        <div className="subinfo__text">{content}</div>
      </div>
    </div>
  );
};
